import { useEffect, useState } from 'react';
import { useScrollLock } from './useScrollLock';

const isOpenOverlay = element => {
    if (!element) {
        return false;
    }

    if (element.classList.contains('MuiModal-hidden') || element.getAttribute('aria-hidden') === 'true') {
        return false;
    }

    const style = globalThis.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number.parseFloat(style.opacity) > 0;
};

/**
 * Detects open overlays (popovers, autocomplete menus, modal drawers, dialogs)
 * and locks background scroll.
 */
export const useAutoScrollLock = () => {
    const [shouldLockScroll, setShouldLockScroll] = useState(false);
    useScrollLock(shouldLockScroll);

    useEffect(() => {
        const checkForOpenOverlays = () => {
            const hasOpenPopover = Array.from(document.querySelectorAll('.MuiPopover-root')).some(popover => {
                if (
                    popover.classList.contains('notification-popover') ||
                    popover.classList.contains('user-bottom-menu') ||
                    popover.classList.contains('from-to-filter')
                ) {
                    return false;
                }

                return isOpenOverlay(popover);
            });

            const hasAutocompleteMenu = Array.from(document.querySelectorAll('.MuiAutocomplete-popper[data-popper-placement]')).some(isOpenOverlay);

            const hasOpenModalDrawer = Array.from(document.querySelectorAll('.MuiDrawer-root.MuiDrawer-modal')).some(isOpenOverlay);

            const hasOpenDialog = Array.from(document.querySelectorAll('.MuiDialog-root')).some(isOpenOverlay);

            setShouldLockScroll(hasOpenPopover || hasAutocompleteMenu || hasOpenModalDrawer || hasOpenDialog);
        };

        let timeoutId;
        const observer = new MutationObserver(() => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(checkForOpenOverlays, 50);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'data-popper-placement', 'aria-hidden'],
        });

        checkForOpenOverlays();

        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
            setShouldLockScroll(false);
        };
    }, []);
};
